type ErrorWithOriginal = Error & { original?: unknown }

interface CustomSentry {
  captureException: (error: unknown) => void
}

export const captureException = (sentry: CustomSentry, err: unknown): void => {
  if (err instanceof Error) {
    sentry.captureException(err)
    return
  }

  // Type guard to check if err is an object with possibly a 'message' property
  const isObjectWithMessage = (e: unknown): e is { message?: unknown } =>
    typeof e === 'object' && e !== null && 'message' in e

  // Extract message if possible
  const msg = isObjectWithMessage(err) && typeof err.message === 'string' ? err.message : 'Unknown error'
  const details = typeof err === 'object' && err !== null ? JSON.stringify(err, null, 2) : String(err)
  const error = new Error(`${msg} | Details: ${details}`)

  if (typeof err === 'object' && err !== null) {
    for (const key of Object.keys(err)) {
      if (key === 'message') continue
      try {
        ;(error as unknown as Record<string, unknown>)[key] = (err as Record<string, unknown>)[key]
      } catch {
        // ignore errors
      }
    }
  }

  ;(error as ErrorWithOriginal).original = err

  sentry.captureException(error)
}
